import { render, staticRenderFns } from "./presentation-file-upload.html?vue&type=template&id=0f85d436&scoped=true&external"
import script from "./presentation-file-upload.js?vue&type=script&lang=js&external"
export * from "./presentation-file-upload.js?vue&type=script&lang=js&external"
import style0 from "./presentation-file-upload.scss?vue&type=style&index=0&id=0f85d436&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f85d436",
  null
  
)

export default component.exports